import {createContext} from 'react';

export const UserContext = createContext({
    currentUser: undefined,
    setCurrentUser: () => {},
    member: undefined,
    setMember: () => {},
    users: [],
    setUsers: () => {},
    // Roster (usersLight) load status. `usersLoading` is true until the first
    // snapshot resolves; `usersError` is set if the listener errors; `usersFromCache`
    // is true until the server confirms the snapshot. A cache-only or errored empty
    // `users` is NOT authoritative — consumers must not treat it as "no members".
    usersLoading: true,
    usersError: false,
    usersFromCache: true
});
